"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LabelsView = void 0;
const core_1 = require("@material-ui/core");
const kpi_header_1 = require("client/components/kpi-header");
const kpi_title_1 = require("client/components/kpi-header/kpi-title");
const floating_page_1 = require("client/components/page/floating-page");
const router_1 = require("client/components/router");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const labels_view_details_1 = require("../labels-view-details");
require("./labels-view.less");
const styles = core_1.createStyles({
    root: {}
});
const decorate = core_1.withStyles(styles);
let LabelsViewUnstyled = class LabelsViewUnstyled extends router_1.TabRouter {
    render() {
        return (React.createElement("div", { className: "" },
            React.createElement(kpi_header_1.KpiHeader, { center: false },
                React.createElement(kpi_title_1.KpiTitle, { label: "Prescribed Labels", subLabel: " " })),
            React.createElement(floating_page_1.FloatingPage, null,
                React.createElement(labels_view_details_1.LabelsViewDetails, null))));
    }
};
LabelsViewUnstyled = __decorate([
    mobx_react_1.observer
], LabelsViewUnstyled);
exports.LabelsView = decorate(LabelsViewUnstyled);



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/labels/modules/labels-view/labels-view.tsx
// module id = 3699
// module chunks = 0